import { cssGenerator } from '@yola/ws-sdk';

const { breakpointNames } = cssGenerator.constants;

export const DESKTOP_BREAKPOINT = breakpointNames.EMPTY;
export const TABLET_BREAKPOINT = `max-${breakpointNames.XL}`;
export const MOBILE_BREAKPOINT = `max-${breakpointNames.MD}`;

export const EDITOR_BREAKPOINTS = [DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, MOBILE_BREAKPOINT];

// Responsive classes cascade from wider breakpoints to narrower ones, so reading a
// value at a breakpoint means walking back up the chain until a token is found.
// `getResponsiveClassValue` resolves one breakpoint at a time and does not walk it.
export const BREAKPOINT_READ_CASCADE = {
  [MOBILE_BREAKPOINT]: [MOBILE_BREAKPOINT, TABLET_BREAKPOINT, DESKTOP_BREAKPOINT],
  [TABLET_BREAKPOINT]: [TABLET_BREAKPOINT, DESKTOP_BREAKPOINT],
  [DESKTOP_BREAKPOINT]: [DESKTOP_BREAKPOINT],
};
